<template>
  <Section :content="trinpod" />
</template>

<script>
// @ is an alias to /src
require('@/assets/css/styles.css');
import Section from '@/components/section.vue';
export default {
  name: 'SectionTrinpod',
  components: {
    Section,
  },
  data() {
    return {
      trinpod: { 
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'What is a TrinPod\u2122?',
        headlineIcon: 'trinity_secure.png',
        paragraphs: [
          'A TrinPod\u2122 models the complete space-time of part of the world linking systems to documents about those systems. When information is requested by an app, a human-based data structure is read into the server\'s conceptual awareness with real-time inference.'
        ],
        id: 'what-is-trinpod',
        image: 'trinpod-image.png',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-neon-blue-grad',
        //learnMoreLink: '/trinpod',
      },
    }
  }
};
</script>
